import { settings } from "app";
import { Error } from "react-admin";
import { important, joditCssClasses } from "./config";
import { getToken } from "core/dataProvider.utils";

export const getValuesList = ({ prefix = "", values }) => {
  return values
    ? Object.entries(values).reduce((acc, [key, val]) => {
        return {
          ...acc,
          [`${important ? "!" : ""}${prefix}${prefix ? "-" : ""}${key}`]: `${key} - ${val}`,
        };
      }, {})
    : {};
};

export const fileUpload = async selectedFile => {
  const headers = {};
  if (getToken) {
    headers.Authorization = getToken();
  } else {
    throw new Error("Необходимо е обновяване на сесиятa!");
  }
  let formData = new FormData();
  formData.append("file", selectedFile);
  try {
    const response = await fetch(`${settings.cmsAdminApi}/static-files`, {
      method: "POST",
      body: formData,
      headers,
    });

    const json = await response.json();

    if (json?.url) {
      return {
        ok: true,
        url: json.url,
      };
    } else {
      throw new Error("Missing full url");
    }
  } catch (e) {
    console.log(e);

    return {
      ok: false,
      error: e,
    };
  }
};

export const findClosestParentByType = (element, type) => {
  if (!element) return null;
  if (element.classList?.contains(joditCssClasses.root)) return null;
  if (Array.isArray(type) ? type.includes(element.tagName) : type === element.tagName) {
    return element;
  }
  return findClosestParentByType(element.parentNode, type);
};

export class AlingTableButton {
  defaultChildTempate = moreClasses => (_editor, key, value) =>
    `<span class="${key} ${moreClasses ? moreClasses : ""}">${value}</span>`;

  constructor({ name, icon, list, tooltip = "", childTemplateExtraClasses = null }) {
    this.name = name;
    this.icon = icon;
    this.list = list;
    this.childTemplate = this.defaultChildTempate(childTemplateExtraClasses);
    this.tooltip = tooltip;
  }

  exec = (editor, _current, control) => {
    const alingPosition = control.control.name;

    if (!this.list[alingPosition]) return;

    const range = editor.selection.range;

    if (!range) return;

    const closestTable = findClosestParentByType(range.startContainer, "TABLE");

    if (!closestTable) return;

    closestTable.style.margin = alingPosition;
  };
}
